module.exports = __webpack_public_path__ + "img/Azad.a188508.png";